import { useSelector, useDispatch } from 'react-redux'
import { Row, Col } from "react-bootstrap";
import { useState, /* useRef, */ useEffect } from 'react';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import HourglassTopIcon from '@mui/icons-material/HourglassTop';
import CheckIcon from '@mui/icons-material/Check';
import Stack from '@mui/material/Stack';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { styled } from '@mui/material/styles';
import { getStyle } from '../../../../libs/todoSlice'
import { getHistoryDetail, setHistorySuccess, getHistorySuccess, setHistoryFail, getHistoryFail } from '../../../../libs/historySlice';
import fontColor from '../../../../lib/fontColor';
import OfficerHistoryDetailSuccess from './OfficerHistoryDetailSuccess';
import OfficerHistoryDetailFail from './OfficerHistoryDetailFail';

const OfficerHistoryDetail = ({ backStep }) => {
    const dispatch = useDispatch()
    const details = useSelector(getHistoryDetail)
    useEffect(() => {
        

        dispatch(setHistorySuccess({
            historysuccess: parseInt(details.importHistories[details.importHistories.length - 1].successDetail?.length)
        }))
        dispatch(setHistoryFail({
            historyfail: details.importHistories[details.importHistories.length - 1].failDetail?.length
        }))
    }, [])
    const countSuccess = useSelector(getHistorySuccess)
    const countFail = useSelector(getHistoryFail)
    // const countSuccess = details.importHistories[details.importHistories.length - 1].success
    // const countFail = details.importHistories[details.importHistories.length - 1].fail
    // function step
    const steps = ['ตรวจสอบข้อมูล', 'กำลังดำเนินการ', 'สำเร็จ'];
    const style = useSelector(getStyle)
    const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
        [`&.${stepConnectorClasses.alternativeLabel}`]: {
            top: 22,
        },
        [`&.${stepConnectorClasses.active}`]: {
            [`& .${stepConnectorClasses.line}`]: {
                backgroundColor:
                    style.primary_color ?? '#053075',
            },
            color: fontColor(style.primary_color)
        },
        [`&.${stepConnectorClasses.completed}`]: {
            [`& .${stepConnectorClasses.line}`]: {
                backgroundColor:
                    style.primary_color ?? '#053075',
            },
            color: fontColor(style.primary_color)
        },
        [`& .${stepConnectorClasses.line}`]: {
            height: 3,
            border: 0,
            backgroundColor:
                theme.palette.mode === 'dark' ? theme.palette.grey[800] : '#eaeaf0',
            borderRadius: 1,
        },
    }));
    const ColorlibStepIconRoot = styled('div')(({ theme, ownerState }) => ({
        border: 'solid',
        borderColor: '#F5F5F5',
        backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[700] : '#fff',
        zIndex: 1,
        color: '#E0E0E0',
        width: 50,
        height: 50,
        display: 'flex',
        borderRadius: '50%',
        justifyContent: 'center',
        alignItems: 'center',
        ...(ownerState.active && {
            backgroundColor:
                '#F3F5FA',
            boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
            color: style.primary_color ?? '#053075',
        }),
        ...(ownerState.completed && {
            backgroundColor:
                style.primary_color ?? '#053075',
        }),
    }));
    function ColorlibStepIcon(props) {
        const { active, completed, className } = props;
        const icons = {
            1: <FormatListBulletedIcon />,
            2: <HourglassTopIcon />,
            3: <CheckIcon />,
        };
        return (
            <ColorlibStepIconRoot ownerState={{ completed, active }} className={className}>
                {icons[String(props.icon)]}
            </ColorlibStepIconRoot>
        );
    }
    // end step
    // tab in success step
    const [value, setValue] = useState('1');
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    // end tab in success step

    return (
        <>
            <Row>
                <Col className="d-flex justify-content-start">
                    <h3
                        style={{
                            margin: 0,
                            padding: 0,
                            border: 'none',
                            cursor: 'pointer'
                        }}
                        onClick={() => {
                            backStep()
                        }}
                    >
                        <ArrowBackIosIcon />
                        รายละเอียดการเพิ่ม
                    </h3>
                </Col>
            </Row>
            {/* ui steps progress */}
            <Row style={{ marginBottom: '40px', marginTop: '20px' }}>
                <Stack sx={{ width: '100%' }} spacing={4}>
                    <Stepper alternativeLabel activeStep={3} connector={<ColorlibConnector />}>
                        {steps.map((label, key) => (
                            <Step key={key}>
                                <StepLabel StepIconComponent={ColorlibStepIcon}>{label}</StepLabel>
                            </Step>
                        ))}
                    </Stepper>
                </Stack>
            </Row>
            {/* end ui steps progress */}
            {/* part body */}
            <Row style={{ marginBottom: '20px', marginTop: '20px' }}>
                <Box sx={{ width: '100%', typography: 'body1' }}>
                    <TabContext value={value}>
                        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                            <TabList onChange={handleChange} aria-label="lab API tabs example" textColor="secondary" indicatorColor="secondary"
                                TabIndicatorProps={{
                                    sx: !!style.secondary_color && {
                                        backgroundColor: `${style.secondary_color} !important`,
                                        color: fontColor(style.secondary_color)
                                    }
                                }}>
                                <Tab label={`รายการที่สำเร็จ (${countSuccess})`} value="1" />
                                <Tab label={`รายการที่ไม่สำเร็จ (${countFail})`} value="2" />
                            </TabList>
                        </Box>
                        <TabPanel value="1">
                            <OfficerHistoryDetailSuccess />
                        </TabPanel>
                        <TabPanel value="2">
                            <OfficerHistoryDetailFail />
                        </TabPanel>
                    </TabContext>
                </Box>
            </Row>
            {/* end part body */}
        </>
    );
}
export default OfficerHistoryDetail;